import React, { PureComponent } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import Helmet from 'react-helmet';

import { BottomAd } from '../ad';
import Heading from '../heading';
import { capitalize } from '../../utilities/formatting';
import { grayBorder } from '../../utilities/styles';

const VIEW_LIST = ['basic', 'advanced', 'wyse'];

export default class CalculatorBase extends PureComponent {
    constructor(props) {
        super(props);

        const { basicInputs, basicOutputs, advancedInputs, advancedOutpus, wyseInputs, wyseOutputs, ...defaultValues } = props;

        this.state = { ...defaultValues };
        this.processInput = this.processInput.bind(this);
    }

    processInput(id, value) {
        this.setState({
            [id]: value
        });
    }

    renderCalculatorTabInner(inputFn, outputFn, chartFn) {
        const { state, processInput } = this;

        return (
                <div
                    css={{
                        padding: 20,
                        backgroundColor: 'white',
                    }}
                >
                    <div>
                        {inputFn(state, processInput)}
                    </div>
                    <div css={{ fontSize: 16 }}>
                        <h3 css={{ textAlign: 'center', marginTop: 24, paddingBottom: 8, borderBottom: '1px solid #eee' }}>Results</h3>
                        {outputFn(state)}
                        {chartFn ? chartFn(state) : null}
                    </div>
                </div>
        );
    }

    renderCalculatorTab(view) {
        const { props } = this;

        const inputFn = props[`${view}Inputs`];
        const outputFn = props[`${view}Outputs`];
        const chartFn = props[`${view}Chart`];
        if (!inputFn || !outputFn) return null;

        return (
            <Tab key={view} eventKey={view} title={capitalize(view)}>
                {this.renderCalculatorTabInner(inputFn, outputFn, chartFn)}
            </Tab>
        );
    }

    render() {
        const { title, inputs, outputs, pathname } = this.props;

        return (
            <div
                css={{
                    width: '100%',
                    '&& .tab-pane': {
                        borderRight: `1px solid ${grayBorder}`,
                        borderBottom: `1px solid ${grayBorder}`,
                        borderLeft: `1px solid ${grayBorder}`,
                    },
                    '&& .nav-tabs': {
                        borderBottom: `1px solid ${grayBorder}`,
                        display: 'flex',
                    },
                    '&& .nav-tabs > li': {
                        flex: 1,
                        textAlign: 'center',
                        marginBottom: -1,
                        float: 'none',
                    },
                    '&& .nav-tabs > li > a:hover': {
                        backgroundColor: grayBorder,
                    },
                    '&&& .nav-tabs > li > a': {
                        borderRadius: 0,
                        borderWidth: 1,
                        marginRight: 0,
                    },
                    '&& .nav-tabs > li.active > a': {
                        backgroundColor: 'white',
                        borderTopColor: grayBorder,
                        borderLeftColor: grayBorder,
                        borderRightColor: grayBorder,
                    }
                }}
            >
                <Helmet
                    title={title}
                    meta={[{ property: 'og:title', content: title }]}
                />
                <Heading>{title}</Heading>
                {inputs ?
                    <div css={{ border: `1px solid ${grayBorder}` }}>{this.renderCalculatorTabInner(inputs, outputs)}</div> :
                    <Tabs id="calculatorTabs" animation={false} defaultActiveKey={'basic'}>
                        {VIEW_LIST.map(view => this.renderCalculatorTab(view))}
                    </Tabs>
                }
                <div css={{ marginTop: 24 }} ><BottomAd key={pathname} /></div>
            </div>
        );
    }
}
